export default __webpack_public_path__ + "static/media/theatro3.6f2cc1de.jpg";